import fastdom from 'fastdom';

/**
 * returns the rendered HTML for the skeleton cards
 *
 * @param dataAttribute
 * @returns {string}
 */
function getCardHtml(dataAttribute = '') {
  return (`
    <li ${dataAttribute} class="nhs-u-margin--bottom-950">
      <div class="nhs-c-summary-card-skeleton nhs-u-flex-column nhs-mq-flex-row--medium nhs-u-gap--500">
          <div class="nhs-c-summary-card-skeleton__placeholder nhs-u-shrink--0 nhs-u-width--1540 nhs-mq-align-self--center-medium nhs-c-image--ratio-12-7"></div>
          <div class="nhs-u-width--full">
              <div class="nhs-c-summary-card-skeleton__placeholder nhs-u-margin--bottom-500 nhs-u-height--550 nhs-u-width--880"></div>
              <div class="nhs-c-summary-card-skeleton__placeholder nhs-u-height--720 nhs-u-margin--bottom-600"></div>
              <div class="nhs-c-summary-card-skeleton__placeholder nhs-u-margin--bottom-400 nhs-u-height--500"></div>
              <div class="nhs-c-summary-card-skeleton__placeholder nhs-u-margin--bottom-400 nhs-u-height--500"></div>
              <div class="nhs-c-summary-card-skeleton__placeholder nhs-u-margin--bottom-400 nhs-u-height--500 nhs-u-width--half"></div>
              <div class="nhs-c-summary-card-skeleton__placeholder nhs-u-height--550 nhs-u-width--1080"></div>
          </div>
      </div>
    </li>
  `);
}

/**
 * getCardSkeleton: builds and returns a string representing the skeleton cards to show.
 * @param count
 * @param dataValue
 * @returns {string}
 */
function getCardSkeleton(count, dataValue) {
  const cards = Array.from({ length: count }, () => getCardHtml(dataValue)).join('');
  return `<ul class="nhs-n1-c-content-card-listing__list nhs-u-gap--700">${cards}</ul>`;
}

/**
 * showSkeletons: creates a set of card skeletons and places them in a given container.
 * @param container
 * @param count
 * @param dataValue
 */
export function showSkeletons(container, count, dataValue) {
  fastdom.mutate(() => {
    if (container) {
      container.innerHTML = getCardSkeleton(count, dataValue);
    }
  });
}

/**
 * clearSkeletons: removes all skeleton cards from a given container.
 * @param container
 */
export function clearSkeletons(container) {
  fastdom.mutate(() => {
    if (container) {
      container.innerHTML = '';
    }
  });
}
